import { ESidebarOptionType } from '../types/enums/sidebar-option-type';
import { IDocumentOption } from '../types/document-option';

export const documentOptions: IDocumentOption[] = [
  {
    type: ESidebarOptionType.Invite,
    icon: 'invite-recipient',
    title: 'invite',
    disableInPreview: true,
  },
  {
    type: ESidebarOptionType.Call,
    icon: 'call',
    title: 'call',
    disableInPreview: true,
  },
  {
    type: ESidebarOptionType.Download,
    icon: 'download',
    title: 'download',
    disableInPreview: true,
  },
  {
    type: ESidebarOptionType.Print,
    icon: 'print',
    title: 'print',
    disableInPreview: true,
  },
];

export const sidebarDocumentOptions: IDocumentOption[] = [
  {
    type: ESidebarOptionType.Recipient,
    icon: 'user',
    title: 'recipient',
    disableInPreview: false,
  },
  {
    type: ESidebarOptionType.Chat,
    icon: 'chat',
    title: 'chat',
    disableInPreview: false,
  },
  {
    type: ESidebarOptionType.Invite,
    icon: 'invite-recipient',
    title: 'invite',
    disableInPreview: true,
  },
  {
    type: ESidebarOptionType.Call,
    icon: 'call',
    title: 'call',
    disableInPreview: true,
  },
  {
    type: ESidebarOptionType.Download,
    icon: 'download',
    title: 'download',
    disableInPreview: true,
  },
  {
    type: ESidebarOptionType.Print,
    icon: 'print',
    title: 'print',
    disableInPreview: true,
  },
  {
    type: ESidebarOptionType.Help,
    icon: 'question-circle',
    title: 'help',
    disableInPreview: true,
  },
  {
    type: ESidebarOptionType.Reject,
    icon: 'reject',
    title: 'reject-deal',
    disableInPreview: true,
  },
];
